export const iconFontAwesomeHumanitarianVirusCovid = (
	<i className="fa-solid fa-virus-covid"></i>
);
